  import api from '../../api/api.js'
  import request from '../../api/request.js'

export default {
  state: ()=>{
    return {
      author:null,
      infor:null
    }
  },
  mutations: {
    initUser (state,infor) {
      state.infor=infor
    },
    initAuthor (state,author) {
      state.author=author
    },
  },
  actions: {
    async getAuthor ({ commit,state }) {
      if(state.author==null){
        const res = await new request(api.m().sysUser_getSessionUser,{}).modepost()
        if(res.status == 200){
          let listAuths = res.data.data.listAuths;
          let authOBbj = {}
          for(let i=0;i<listAuths.length;i++){
            authOBbj["auth_"+listAuths[i]]=true
          }
          commit('initAuthor',authOBbj)
          commit('initUser',res.data.data)
        }
        return state.author
      }else{
        return state.author
      }
    },
  },
  getters: {

  }
};


